import React from 'react';
import SSMCheckBox from '../ssm-checkbox/ssm-checkbox';
import TextWithTooltip from '../../../../components/text-with-tooltip';
import { Desktop, Mobile } from '../../../../app-responsive';

const ISDNMigrationTable = (props) => {
  const { siteServicesArray, onCheckBoxChange, isdnServiceDetails, tableHeadings, migrationAdvertiseChecks, siteId } = props;

  const getServiceTypeText = (type) => {
    switch (type) {
      case 'GDN':
        return isdnServiceDetails.gdnText;
      case 'PrimaryFNN' :
        return isdnServiceDetails.primaryFNN;
      default:
        return isdnServiceDetails.auxillary;
    }
  };

  const desktopMigrationTable = siteServicesArray.map(service => (
    <div key={service.number} className="row migrate-row">
      <div className={`col-3 ${service.type.toLowerCase()}`}> {getServiceTypeText(service.type)} </div>
      <div className="col-3">{service.number}</div>
      <div className="col-3"> {isdnServiceDetails.migrateToTiptHeadingText} </div>
      <div className="col-3">
        <SSMCheckBox
          checkBoxId={`${siteId}-${service.type}-${service.number}-checkbox`}
          checkBoxLabel=""
          checkBoxDesc=""
          checkBoxChecked={service.type === 'GDN' || migrationAdvertiseChecks[`${siteId}-${service.type}-${service.number}-checkbox`]}
          onCheckBoxStatusChanged={onCheckBoxChange}
        />
      </div>
    </div>
  ));

  const mobileMigrationTable = siteServicesArray.map(service => (
    <div key={service.number} className="row migrate-row">
      <div className={`col-12 ${service.type.toLowerCase()}`}> {getServiceTypeText(service.type)} </div>
      <div className="col-12 migrate-advertise-col">
        <SSMCheckBox
          checkBoxId={`${siteId}-${service.type}-${service.number}-checkbox`}
          checkBoxLabel={isdnServiceDetails.advertisedNumbersHeadingText}
          checkBoxDesc=""
          checkBoxChecked={service.type === 'GDN' || migrationAdvertiseChecks[`${siteId}-${service.type}-${service.number}-checkbox`]}
          onCheckBoxStatusChanged={onCheckBoxChange}
        />
      </div>
      <div className="col-6 migrate-fnn-mobile-col"><strong>{isdnServiceDetails.fnnHeadingText}</strong></div>
      <div className="col-6 migrate-fnn-mobile-col"> <strong>{isdnServiceDetails.migrateAllTiptHeadingText} </strong></div>
      <div className="col-6 migrate-fnn-mobile-col-data">{service.number}</div>
      <div className="col-6 migrate-fnn-mobile-col-data"> {isdnServiceDetails.migrateToTiptHeadingText} </div>
    </div>
  ));

  return (
    <div className="serviceTable">
      <div className="row headings hidden-mobile">
        <div className="col-6"><h2>{tableHeadings.currentServiceDetails}</h2></div>
        <div className="col-6"><h2>{tableHeadings.confirmOrder}</h2></div>
      </div>
      <div className="row column-headings hidden-mobile">
        <div className="col-3">
          <TextWithTooltip
            labelText={isdnServiceDetails.typeHeadingText}
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="isdn-migration-table-type-tooltip"
            toolTipText={isdnServiceDetails.typeTooltipText}
          />
        </div>
        <div className="col-3">{isdnServiceDetails.fnnHeadingText}</div>
        <div className="col-3">{isdnServiceDetails.migrateAllTiptHeadingText}</div>
        <div className="col-3">
          <TextWithTooltip
            labelText={isdnServiceDetails.advertisedNumbersHeadingText}
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="isdn-migration-table-advertise-tooltip"
            toolTipText={isdnServiceDetails.advertisedNumberToolTipText}
          />
        </div>
      </div>
      <Desktop>
        {desktopMigrationTable}
      </Desktop>
      <Mobile>
        {mobileMigrationTable}
      </Mobile>
    </div>
  );
};

export default ISDNMigrationTable;
